export const ESC_KEYCODE = 27;

export const TEST_IDS = {
    CLUSTER_DIV: 'cluster-div',
    EDIT_NAME_FIELD: 'edit-name-field-input',
    ICON_PENCIL: 'edit-name-field-icon-pencil',
    LOADING_CLUSTER: 'loading-cluster',
    CLUSTER_FORM: 'cluster-form',
};
